import axios from "axios";
import { GafOktaManager } from "../auth/gaf-okta-auth";
import { store } from "../store";
import AppTracking from "../AppTracking";
import { getCustomerIDFromStore, getQueryString, getPersistData, getContractorIDFromStore, setSessionValue } from "./utils";
import { CONTRACTOR_ID } from "../constants/storageKeys";

/**
 * @category Services
 * @param {object} endpoint
 */
export const fetchAPI = (endpoint) => {
    return axios(endpoint);
};

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.delete["Content-Type"] = "application/json";
axios.interceptors.request.use(
    (config) => {
        // perform a task before the request is sent
        // const urlParams = new URLSearchParams(window.location.search);
        const url = window.location.href;
        const accessToken = GafOktaManager.storage.info.accessToken;
        const disableHeader = config["disableHeader"];

        const state = store.getState();
        const persistData = getPersistData();

        const customerId = getQueryString("customerID", url) || getCustomerIDFromStore(false);
        const isAdmin = (state.adminData.userInfo && state.adminData.userInfo.isAdmin) || false;
        const isTm = (state.adminData.userInfo && state.adminData.userInfo.isTm) || false;
        const contractorId =
            getQueryString("contractorId", url) ||
            (state.adminData.contractorSelection && state.adminData.contractorSelection.contractorId) ||
            (persistData && persistData.contractorId) ||
            (config && config["contractorId"]); // specifically for admin trying to fetch submitted warranty data
            // CONTRACTOR_ID added for the API call which is used in validateOwnerEmail

            if (!getContractorIDFromStore() && contractorId) {
                    setSessionValue(CONTRACTOR_ID, contractorId);              
                    }
            if (!disableHeader) {
            if (contractorId && (isAdmin || isTm)) {
                config.headers["contractorId"] = decodeURIComponent(contractorId);
            }
            if (customerId && !isAdmin && !isTm) {
                config.headers["customerID"] = decodeURIComponent(customerId);
            }
            config.headers["TrackingId"] = AppTracking?.id;
            config.headers["Authorization"] = `Bearer ${accessToken}`;
        }

        return config;
    },
    (error) => {
        // handle the error
        window["AppInsightTrace"].trackException(error);
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (config) => {
        // perform a task before the response is recieved
        return config;
    },
    (error) => {
        // handle the error
        window["AppInsightTrace"].trackException(error);

        /*// commented below code due to `autoRenew` as true
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            GafOktaManager.getRenewToken({
                resolve: () => axios(originalRequest),
                reject: () => redirectToCCZ(),
            });
        }*/
        return Promise.reject(error);
    }
);
